import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { capturarOrigem } from './v2/origem';

// De onde a pessoa veio — ANTES do primeiro desenho, enquanto a URL de
// entrada (com os utm_ e o /r/CODIGO) ainda é a que ela abriu. Ver origem.ts.
capturarOrigem();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();

const enableDevSW = window.location.search.includes('enable-sw=true');
// Detecta Capacitor app — em WebView nativo, SW causa cache stale
// (CSS antigo aplica depois do CSS novo, gerando 'pisca certo, depois estica').
// Pra app, vale fazer cleanup de SW pre-existente registrado por sessao anterior.
const isCapacitorApp = !!(window as any).Capacitor?.isNativePlatform?.();

if (isCapacitorApp && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((reg) => reg.unregister().catch(() => {}));
  }).catch(() => {});
  // Tambem limpa caches do SW pra forcar fetch direto da rede
  if ('caches' in window) {
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
  }
}

if (!isCapacitorApp && 'serviceWorker' in navigator && (process.env.NODE_ENV === 'production' || enableDevSW)) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((error) => console.error('Service worker registration failed', error));
  });
}
